import React from "react";
import { Tooltip } from "antd";
import { ACWRDot } from "./ACWRDot";

// Pure — the row of ACWR dots + its tooltip (matches .status-tracker-acwr-dot-container).
export const AcwrDots = ({ dots, tooltip, uniqueKey = "" }) => (
    <Tooltip title={tooltip}>
        <div className="stv2-status-tracker-acwr-dot-container">
            {dots.map((dot, idx) => (
                <ACWRDot key={`ACWRCircle${uniqueKey}${idx}`} color={dot.color} />
            ))}
        </div>
    </Tooltip>
);
